<template>
  <ContentLoader
      :speed=2
      :width=1000
      :height=420
      viewBox="0 0 1000 420"
      backgroundColor="#eaeced"
      foregroundColor="#ffffff">

    <rect x="0" y="0" rx="3" ry="3" width="1000" height="50"/>

    <rect x="710" y="70" rx="3" ry="3" width="120" height="35"/>
    <rect x="840" y="70" rx="3" ry="3" width="120" height="35"/>

    <rect x="80" y="80" rx="3" ry="3" width="60" height="20"/>
    <rect x="260" y="80" rx="3" ry="3" width="140" height="20"/>
    <rect x="0" y="150" rx="3" ry="3" width="1000" height="2"/>

    <rect x="710" y="180" rx="3" ry="3" width="120" height="35"/>
    <rect x="840" y="180" rx="3" ry="3" width="120" height="35"/>

    <rect x="80" y="180" rx="3" ry="3" width="60" height="20"/>
    <rect x="260" y="180" rx="3" ry="3" width="140" height="20"/>
    <rect x="0" y="240" rx="3" ry="3" width="1000" height="2"/>

    <rect x="710" y="270" rx="3" ry="3" width="120" height="35"/>
    <rect x="840" y="270" rx="3" ry="3" width="120" height="35"/>

    <rect x="80" y="270" rx="3" ry="3" width="60" height="20"/>
    <rect x="260" y="270" rx="3" ry="3" width="140" height="20"/>
    <rect x="0" y="330" rx="3" ry="3" width="1000" height="2"/>

    <rect x="710" y="360" rx="3" ry="3" width="120" height="35"/>
    <rect x="840" y="360" rx="3" ry="3" width="120" height="35"/>

    <rect x="80" y="360" rx="3" ry="3" width="60" height="20"/>
    <rect x="260" y="360" rx="3" ry="3" width="140" height="20"/>

  </ContentLoader>
</template>
<script>
import {ContentLoader} from "vue-content-loader"

export default {
  name: 'loander-ultimos-diarios',
  components: {
    ContentLoader
  },
  data() {
    return {}
  }
}
</script>
<style>
</style>
